<template>
  <div
    :style="{
      order: buildingOrder
    }"
    class="building-wrapper"
  >
    <img
      class="building-icon"
      :class="{
        'building-icon-construction-camp': buildingKey === Buildings.ConstructionCamp
      }"
      :src="`/img/buildings/${buildingKey}.png`"
      alt=""
      @click="openBuilding"
    />
    <div class="building-board-name">{{ $t(buildingKey) }}</div>

    <div v-if="recipes && buildingClaimItems.length" class="claim-option">
      <div class="crafting-items">
        <div v-for="product of claimableProducts.slice(0, 3)" :key="product.tokenAddress" class="claim-item">
          <img
            class="claim-image"
            :src="$getIconToken(product, BigNumber(product.recipeId).toNumber())"
            :alt="tokenMetaData(blockchain.contracts, product.tokenAddress).label"
          />
          <p class="claim-current">
            <span v-if="singleClaimableProductAmount && !BigNumber(singleClaimableProductAmount || 0).isZero()">
              {{ singleClaimableProductAmount }}
            </span>
          </p>
        </div>
      </div>

      <button
        class="btn-primary"
        type="button"
        @click="
          () => {
            if (!buildingClaimItems.length) return;
            if (buildingClaimItems.length > 1) {
              showPopupValue = true;
            } else {
              claimCraftedTokensFromBuildingClaimItems(buildingClaimItems[0]);
            }
          }
        "
      >
        <span> {{ $t('craftingClaim') }} </span>
        <img :src="`/img/icons/chevronRight.svg`" alt="chevron right" />
      </button>
    </div>

    <div v-else-if="!BigNumber(minedBalance!).isZero()" class="claim-option">
      <div class="crafting-items">
        <div class="claim-item">
          <img
            class="claim-image"
            :src="
              tokens[
                building.buildingKey === Buildings.Dock
                  ? Tokens.pearl
                  : (tokensConfig[building.miningToken!]?.name?.contract as Tokens)
              ]?.toString()
            "
            alt=""
          />
          <p class="claim-current">
            <span v-if="singleClaimableProductAmount && !BigNumber(singleClaimableProductAmount || 0).isZero()">
              {{ singleClaimableProductAmount }}
            </span>
          </p>
        </div>

        <div v-if="!BigNumber(minedExtraRewardBalance).isZero()" class="claim-item">
          <img
            class="claim-image"
            :src="
              tokens[
                tokenMetaData(
                  blockchain.contracts,
                  blockchain.contracts?.[building.miningToken!]?.addresses?.secondaryToken!
                )?.name?.contract as Tokens
              ]?.toString()
            "
            alt=""
          />
          <p class="claim-current">
            <span v-if="singleClaimableProductAmount && !BigNumber(singleClaimableProductAmount || 0).isZero()">
              {{ singleClaimableProductAmount }}
            </span>
          </p>
        </div>
      </div>

      <button
        class="btn-primary"
        type="button"
        @click="
          () => {
            if (!buildingClaimItems.length && BigNumber(minedBalance).isZero()) return;
            if (buildingClaimItems.length > 1) {
              showPopupValue = true;
            } else {
              claimRewardHandler();
            }
          }
        "
      >
        <span> {{ $t('craftingClaim') }} </span>
        <img :src="`/img/icons/chevronRight.svg`" alt="chevron right" />
      </button>
    </div>

    <div v-else-if="products?.length" class="recipes-box" @click="openBuilding">
      <div v-for="(product, index) of products.slice(0, 3)" :key="index" class="recipe">
        <img
          class="crafting-item-image"
          :src="$getIconToken(product, BigNumber(product.recipeId).toNumber())"
          :alt="tokenMetaData(blockchain.contracts, product.tokenAddress)?.label"
        />
      </div>
    </div>

    <div v-else-if="buildingKey === Buildings.Dock" class="recipes-box" @click="openBuilding">
      <div class="recipe">
        <img
          class="crafting-item-image"
          :src="tokens[tokensConfig.blackPearl?.name?.contract as Tokens].toString()"
          :alt="'pearl'"
        />
      </div>
      <div class="recipe">
        <img
          class="crafting-item-image"
          :src="tokens[tokensConfig.pearl?.name?.contract as Tokens].toString()"
          :alt="'pearl'"
        />
      </div>
    </div>

    <div
      v-else-if="buildingKey === Buildings.Forest || buildingKey === Buildings.Cave"
      class="recipes-box"
      @click="openBuilding"
    >
      <div v-if="expeditionState">
        <UIHalloweenCountdownTimer :target="expeditionState.endsAt" />
      </div>
      <div v-else>{{ t('buildingWrapperStartExpedition') }}</div>
    </div>

    <div v-else-if="buildingKey === Buildings.Manor" class="recipes-box" @click="openBuilding">
      <div class="earned-wrapper">
        <span>{{ rent.$state.userClaimableEarnings }}</span>
        <img style="width: 50px; height: 50px" src="/img/tokens/doubloon.png" alt="doubloon" />
      </div>
    </div>

    <div v-else-if="buildingKey === Buildings.Barbershop" class="avatar-box">
      <el-avatar v-if="userData?.user.avatarUrl" :src="userData.user.avatarUrl" :size="50" class="avatar-primary" />
    </div>

    <div v-else-if="buildingKey === Buildings.Seller && sellerData && isSellerOpen" class="recipes-box">
      <div
        v-for="(product, index) of sellerData.filter((item) => item.amount > 0).slice(0, 3)"
        :key="index"
        class="recipe"
      >
        <img
          class="crafting-item-image"
          :src="tokens[tokenMetaData(blockchain.contracts, product.tokenAddress).name.contract as Tokens].toString()"
          :alt="tokenMetaData(blockchain.contracts, product.tokenAddress)?.label"
        />
      </div>
    </div>
    <div
      v-else-if="buildingKey === Buildings.Seller && !isSellerOpen"
      class="sellerStatus"
      :class="{ 'ru-locale': $i18n.locale === 'ru' }"
    >
      <SellerStatus />
    </div>

    <div v-else-if="building.miningToken" class="recipes-box" @click="openBuilding">
      <div class="recipe">
        <img
          class="crafting-item-image"
          :src="
            tokens[
              tokenMetaData(blockchain.contracts, blockchain.contracts[building.miningToken].addresses.secondaryToken!)
                ?.name?.contract as Tokens
            ]?.toString()
          "
          :alt="'pearl'"
        />
      </div>
      <div
        v-if="
          tokensConfig[building.miningToken]?.name?.contract !==
          (tokenMetaData(blockchain.contracts, blockchain.contracts[building.miningToken].addresses.secondaryToken!)
            ?.name?.contract as Tokens)
        "
        class="recipe"
      >
        <img
          class="crafting-item-image"
          :src="tokens[tokensConfig[building.miningToken]?.name?.contract as Tokens].toString()"
          :alt="'pearl'"
        />
      </div>
    </div>

    <el-dialog
      v-model="showPopupValue"
      :title="$t(buildingKey)"
      :fullscreen="$device.isMobile"
      :append-to-body="true"
      :class="{ 'ru-locale': $i18n.locale === 'ru' }"
      @close="store.openedBuilding = null"
    >
      <div class="claimItemsWrapper">
        <CraftingReadyForClaimMaterials
          :selected-building="building"
          :token-metadata-computed="
            tokenMetaData(blockchain.contracts, claimableProducts?.[0].tokenAddress || ZeroHash)
          "
          :disabled="isClaiming"
          :is-claim-button-loading="isLoadingClaimButton"
          @claim-load-state-changed="
            (isLoading) => {
              if (!isLoading) showPopupValue = false;
              isClaiming = isLoading;
            }
          "
        />
      </div>
    </el-dialog>
  </div>
</template>

<script setup lang="ts">
import { Crafting__factory, Mine__factory } from 'public/abi/evm/types';
import useRecipesResponseReformatter from '~/composables/useRecipesResponseReformatter';
import useUserActivityManager from '~/composables/useUserActivityManager';
import type { BuildingProps, RecipeProduct, RecipeProps } from '~/types/crafting';
import { useWalletInfo, useWeb3ModalAccount } from '@web3modal/ethers/vue';
import { BigNumber } from 'bignumber.js';
import { tokenMetaData } from '~/utils';
import { AbiCoder, formatEther, ZeroHash } from 'ethers';
import { Buildings, Tokens, tokensConfig } from '~/utils/constants';
import tokens from '~/public/img/tokens';
import type { IUserModel } from '~/types/apiService';
import type { SellerItem } from '~/types/seller';
import { encodeIndexes } from '~/utils/crafting';
import { modifyHistoryHashStatus, saveHashToLocalStorage } from '~/utils';
import { Formatters } from '~/utils/formatters/formatters';
import { getNftValueByAddress } from '~/utils/referral';
import { ElNotification } from 'element-plus';
import UIHalloweenCountdownTimer from '~/components/Halloween/ui/UIHalloweenCountdownTimer.vue';
import type { HalloweenLocation } from '~/types/halloween/location';
import { useRentEventStore } from '~/stores/rent-event-store';

const { apiUrl, blockchain } = useEnvs();
const { splitActivitiesToChunks } = useUserActivityManager();
const { getProvider } = useProvider();
const { address } = useWeb3ModalAccount();
const { walletInfo } = useWalletInfo();
const { $errorHandler } = useNuxtApp();
const { earned } = useTokensReader();
const { reformatRecipesResponse } = useRecipesResponseReformatter();
const rent = useRentEventStore();

const { sendContractMethod } = useSendContractMethod();
const { t } = useI18n();
const store = useMainStore();
const { claimReward } = useStakingMethods();
const { claimMinedTokens } = useMineLicense();
const sellerData = inject<Ref<SellerItem[]>>('sellerData');
const isSellerOpen = inject<Ref<boolean, boolean>>('sellerIsOpen');

const { data: userData } = useNuxtData<IUserModel>('userData');

const halloween = useHalloweenStore();
const expeditionState = computed(() => {
  const location: HalloweenLocation | null =
    buildingKey.value === Buildings.Forest ? 'forest' : buildingKey.value === Buildings.Cave ? 'cave' : null;
  return !location ? null : halloween.$state.statefulUserExpeditions.find((exp) => exp.location === location) ?? null;
});

const showPopupValue = ref(false);

const isClaiming = ref(false);
const selectedRecipeId = ref<string>();
const products = ref<(RecipeProduct & { recipeId: RecipeProps['recipeId'] })[]>([]);
const building = computed(() => props.building);
const buildingHash = computed(() => props.building.buildingHash || ZeroHash);
const buildingKey = computed(() => props.building.buildingKey || '');
const isLoadingClaimButton = ref(false);
const minedBalance = ref('0');
const minedExtraRewardBalance = ref('0');

const buildingClaimItems = computed(() => {
  return store.getClaimItemsForBuilding(buildingHash.value);
});

const props = defineProps<{
  building: BuildingProps;
}>();

const emit = defineEmits<{
  (e: 'open-building', payload: { building: BuildingProps; recipes: RecipeProps[] }): void;
}>();

watch(
  [address, () => props.building.miningToken, () => store.notificationUpdateVersion],
  async ([newAddress, newToken]) => {
    if (!newAddress || (!newToken && props.building.buildingKey !== Buildings.Dock)) {
      minedBalance.value = '0';
      return;
    }

    const mineAddress = blockchain.contracts[newToken!].addresses.mine;

    if (props.building.buildingKey === Buildings.Dock || !mineAddress) {
      minedBalance.value = await earned(newAddress, Tokens.pearl);
      minedExtraRewardBalance.value = '0';
      return;
    }
    const mineContract = Mine__factory.connect(mineAddress, getProvider());
    const minedContractBalance = await mineContract.mined(newAddress);

    minedBalance.value = Number(formatEther(minedContractBalance[0])).toFixed(2);
    minedExtraRewardBalance.value = Number(formatEther(minedContractBalance[1])).toFixed(2);
  },
  { immediate: true }
);

const claimableProducts = computed(() => {
  // Extract products from buildingClaimItems
  const claimableProductsList: (RecipeProduct & { recipeId: RecipeProps['recipeId'] })[] = [];

  buildingClaimItems.value.forEach((claimItem) => {
    claimItem.recipe.products.forEach((product, index) => {
      const existingProduct = claimableProductsList.find((p) => p.tokenAddress === product.tokenAddress);
      if (!existingProduct) {
        claimableProductsList.push({
          productId: index, // Add missing productId
          ...product,
          recipeId: claimItem.recipe.recipeId.toString()
        });
      }
    });
  });

  return claimableProductsList;
});

const buildingOrder = computed(() => {
  if (buildingKey.value === Buildings.Manor) {
    return 0;
  }
  if (buildingKey.value === Buildings.Tavern) {
    return 1;
  }
  if (buildingClaimItems.value.length || !BigNumber(minedBalance.value).isZero()) {
    return 2;
  }
  return 3;
});

// TODO: refactoring copy paste in MobileBuildingRecipeBoard
const singleClaimableProductAmount = computed(() => {
  if (!claimableProducts.value || (claimableProducts.value && claimableProducts.value?.length > 1)) {
    return 0;
  }

  const isNFT = tokenMetaData(blockchain.contracts, claimableProducts.value[0]?.tokenAddress)?.interface === 'erc721';

  const minValue = buildingClaimItems.value.reduce(
    (acc, claimItem) =>
      BigNumber(acc)
        .plus(BigNumber(claimItem.available).multipliedBy(claimItem.recipe.products[0]?.quantityMin || 0))
        .decimalPlaces(1)
        .toNumber(),
    0
  );

  const maxValue = buildingClaimItems.value.reduce(
    (acc, claimItem) =>
      BigNumber(acc)
        .plus(BigNumber(claimItem.available).multipliedBy(claimItem.recipe.products[0]?.quantityMax || 0))
        .decimalPlaces(1)
        .toNumber(),
    0
  );

  if (!BigNumber(minedBalance.value).isZero() && BigNumber(minedExtraRewardBalance.value).isZero()) {
    return BigNumber(minedBalance.value).decimalPlaces(2).toNumber();
  }

  // Return only maximum if min and max are equal
  if (!isNFT && minValue === maxValue) {
    return maxValue;
  }

  return isNFT
    ? buildingClaimItems.value.reduce((acc, claimItem) => acc + claimItem.available, 0)
    : `${minValue} - ${maxValue}`;
});

const { data: _recipes } = await useFetch<RecipeProps[]>(() => `/crafting/buildings/${buildingHash.value}/recipes`, {
  baseURL: apiUrl,
  watch: [buildingHash],
  key: `buildingRecipes${buildingHash.value}`,

  onResponse: ({ response }) => {
    const allProducts: (RecipeProduct & { recipeId: RecipeProps['recipeId'] })[] = response._data
      .filter((recipe: RecipeProps) => recipe.products.length && recipe.isActive)
      .map((recipe: RecipeProps) => recipe.products.map((product) => ({ ...product, recipeId: recipe.recipeId })));
    const productsSet: (RecipeProduct & {
      recipeId: RecipeProps['recipeId'];
    })[] = [];

    allProducts.flat().forEach((product) => {
      if (!productsSet.some((item) => item.tokenAddress === product.tokenAddress)) {
        productsSet.push(product);
        products.value = products.value.concat(product);
      }
    });
    selectedRecipeId.value = response._data[0]?.recipeId;
  }
});

const recipes = computed(() => {
  return _recipes.value ? reformatRecipesResponse(_recipes.value) : null;
});

// userActivity fetching is now handled by useUnclaimedModifiers composable

const claimCraftedTokensFromBuildingClaimItems = async (claimItem: any) => {
  isLoadingClaimButton.value = true;

  try {
    // Use the same pattern as CraftingReadyForClaimMaterials
    const recipeIds = [BigNumber(claimItem.recipe.recipeId).toNumber()];
    const recipeIndexes = [claimItem.id] as Record<number, number>[];

    const [recipesFormatted, indexesFormatted] = splitActivitiesToChunks(recipeIds, recipeIndexes);
    const recipeIndexesEncoded = encodeIndexes(indexesFormatted);

    const claimTx = await sendContractMethod({
      contract: Crafting__factory.connect(blockchain.contracts.crafting, getProvider()),
      methodName: 'claimRecipes',
      args: [recipesFormatted, recipeIndexesEncoded]
    });

    if (!claimTx?.hash) return;

    const txReceipt = await claimTx?.wait();

    if (txReceipt) {
      const abiCoder = new AbiCoder();
      const amount = formatEther(abiCoder.decode(['uint'], txReceipt.logs[0].data)[0]);

      let description: string = '';

      const methodName = tokenMetaData(blockchain.contracts, claimItem.recipe.products[0]?.tokenAddress!)?.methodName;
      const isNFT =
        tokenMetaData(blockchain.contracts, claimItem.recipe.products[0]?.tokenAddress!).interface === 'erc721';

      description = `${t(methodName || '')} ${Formatters.text.firstLetterUppercase(claimItem.recipe.products[0] ? getNftValueByAddress(blockchain.contracts, { ...claimItem.recipe.products[0], productId: 0 }) : '')}`;

      if (!isNFT) {
        description = `(${BigNumber(amount).decimalPlaces(2)} ${t(methodName || '')})`;
      }

      saveHashToLocalStorage(`${t('dashboardPurchasesClaimed')} ${description}`, claimTx.hash);
    }

    store.updateVersion();

    await claimTx?.wait();

    if (claimTx?.hash) {
      modifyHistoryHashStatus(claimTx.hash, 'Done');
      store.updateVersion();
    }
  } catch (error) {
    console.error(error, 'error on claim');
    ElNotification.error({
      title: '',
      message: 'Error while claiming crafted token'
    });
  } finally {
    isLoadingClaimButton.value = false;
  }
};

const claimRewardHandler = async () => {
  if (!address.value) {
    alert('Please unlock wallet!');
    return;
  }

  try {
    isLoadingClaimButton.value = true;
    const receipt =
      buildingKey.value === Buildings.Dock
        ? await claimReward(() => {}, Tokens.pearl)
        : await claimMinedTokens(() => {}, props.building.miningToken!);

    if (!receipt?.hash) return;

    await PearlApiService.pushActivity(apiUrl, {
      address: address.value ?? '',
      transactionHash: receipt.hash,
      value: 0,
      type: 'REWARD_CLAIM'
    });
    saveHashToLocalStorage(t('notificationClaimReward'), receipt.hash);
    store.updateVersion();

    await receipt?.wait();

    isLoadingClaimButton.value = false;
    minedBalance.value = '0';
    modifyHistoryHashStatus(receipt.hash, 'Done');
    store.updateVersion();
  } catch (e: unknown) {
    isLoadingClaimButton.value = false;
    if (walletInfo.value?.name) {
      const errorMessage = getCancelErrorMessage(e, walletInfo.value.name);
      $errorHandler(t('notificationFailedToUnlock') + t(errorMessage));
    }
  }
};

const openBuilding = () => {
  emit('open-building', {
    building: props.building,
    recipes: recipes.value ?? []
  });
};
</script>

<style scoped lang="scss">
.claimItemsWrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;
  align-items: center;
}

.building-wrapper {
  position: relative;
  height: 75px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  border-radius: 12px;
  border: 1px solid #1e353e;
  background: #041a27b2;
  padding: 8px;

  .building-icon {
    position: absolute;
    left: 5px;
    top: -55px;
    width: 120px;
  }

  .building-icon-construction-camp {
    top: -45px;
  }

  .building-board-name {
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 0 14px;
    border-radius: 15px;
    border: 1px solid #1e353e;
    background: rgba(0, 0, 0, 0.8);
    font-size: 12px;
    font-weight: 600;
    line-height: 21.3px;
    color: white;
    max-width: 175px;
    text-align: center;
  }

  .btn-primary {
    position: absolute;
    bottom: 8px;
    right: 12px;
    padding: 8px;
    height: 44px;
    width: 160px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 3px;

    @media (max-width: 460px) {
      max-width: 160px;
      width: max-content;
    }
  }

  .crafting-items {
    position: absolute;
    top: -25px;
    right: 12px;
    width: fit-content;
    height: 35px;
    background: linear-gradient(#60ff7c 40%, #04202b 130%);
    border-radius: 10px;
    border: 1px solid #ffffff;
    box-shadow: 0 0 10px #ddcead;
    display: flex;
    align-items: center;
    padding: 0 5px;

    .claim-item {
      display: flex;
      gap: 5px;

      .claim-image {
        width: 30px;

        &[alt='nftChristmasShip'] {
          width: 25px;
          height: 25px;
          border-radius: 5px;
        }

        &[alt='nftChristmasPalm'] {
          width: 25px;
          height: 25px;
        }
      }

      .claim-current {
        color: white;
        font-weight: 700;

        padding: 0;
        margin: 0;
      }
    }
  }

  .recipes-box {
    display: flex;
    gap: 10px;

    @media screen and (max-width: 376px) {
      gap: 4px;
    }

    .recipe {
      width: 52px;
      height: 52px;
      border: 1px solid #1e353e;
      border-radius: 12px;
      background-color: #041a27;
      box-shadow: 2px 3px 5px rgba(0, 0, 0, 0.25);

      .crafting-item-image {
        width: 50px;

        &[alt='nftChristmasShip'] {
          border-radius: 5px;
        }
      }
    }
  }

  .avatar-box {
    display: flex;
    width: 52px;
    height: 52px;
  }

  .sellerStatus.ru-locale .sellerModalClosest {
    font-size: 18px;
  }
}

.earned-wrapper {
  border: 1px solid #1e353e;
  border-radius: 12px;
  background-color: #041a27;
  box-shadow: 2px 3px 5px rgba(0, 0, 0, 0.25);
  width: fit-content;
  display: flex;
  align-items: center;
  gap: 8px;
  padding-left: 8px;
}
</style>
